module.exports = __webpack_public_path__ + "static/media/ziplyne.9d487cac.svg";